import { getRandomInt } from './results';

export const getRecommendedContent = function () {
	const { recommended_content: score_recommendations, userData, slides } = this.props;
	const contents = [];

	/**
	 * 1. Score Based Recommended Content
	 */
	if (score_recommendations) {
		if (score_recommendations.length > 1) {
			// Get the recommendation based on the user's score
			for (let i = 0; i < score_recommendations.length; i++) {
				const upperLimit = (100 / score_recommendations.length) * (i + 1);
				if (userData.score < upperLimit) {
					contents.push(score_recommendations[i]);
					break;
				}
			}
		} else {
			// Add the one and only recommended content
			contents.push(score_recommendations[0]);
		}
	}

	/**
	 * 2. Answer Based Recommended Content
	 */
	const answer_recommendations = [];
	Object.keys(userData.dimensions).map((d) => {
		Object.keys(userData.dimensions[d].results).map((id) => {
			// Get the related slide for the question with the current ID
			const slide = slides[slides.indexOf(slides.filter((s) => s.ID === parseInt(id))[0])];

			// Get the selected answer(s)
			let selection;
			if (slide.input_type === 'scale' && slide.scale_options.type === 'percentage') {
				// Exception for percentage scales, since the 'answers' key doesn't represent the answer index but the absolute slider value
				selection = userData.dimensions[d].results[id].answerIndex;
			} else {
				selection = userData.dimensions[d].results[id].answers;
			}

			// Convert number to array to make it 'loopable'
			if (Number.isInteger(selection)) selection = [selection];

			// Check if there are any recommendations for each given answer
			selection.forEach((value) => {
				if (slide.answers[value].recommended_content) {
					answer_recommendations.push(slide.answers[value].recommended_content);
				}
			});
		});
	});

	if (answer_recommendations.length) {
		// If there are multiple answer based recommendations choose a single recommendation by random
		contents.push(answer_recommendations.length > 1 ? answer_recommendations[getRandomInt(answer_recommendations.length)] : answer_recommendations[0]);
	}

	return contents;
};
